const initialState = false

const searchiconClick = (state = initialState, action) => {
  switch (action.type) {
    case 'searchClick':
      return !state

    default:
      return state
  }
}
export default searchiconClick
